<template>
  <div class="commodity">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getLikeData()"
    >
      <span v-for="(item,index) in goods_list" :key="index" class="card" @click="toDetail(item.goodsNo)">
        <div class="img" ><img :src="item.goodsImg" alt=""></div>
        <div class="title">
            <img src="@/assets/首页/taobao.png" alt="" v-if="item.source == 1">
            <img src="@/assets/首页/tmall.png" alt="" v-else-if="item.source == 2">
            <img src="@/assets/首页/JD.png" alt="" v-else-if="item.source == 3">
            <img src="@/assets/首页/pdd.png" alt="" v-else-if="item.source == 4">
            <img src="@/assets/首页/wph.png" alt="" v-else-if="item.source == 5">
          <span>{{item.goodsName}}</span>
        </div>
        <div class="shop"><img src="@/assets/首页/shop.png" alt="">{{item.shopTitle}}</div>
        <div class="profit">
          <div class="coupon_discount">券￥{{item.coupon}}</div>
          <div class="profit_tips">{{item.backAmount}}</div>
        </div>
        <div class="bottom">
          <div class="price">
            <span >￥{{item.goodsPrice}}</span>
            <span>￥{{item.originalPrice}}</span>
          </div>
          <div class="sales_tip">{{item.sold}}</div>
        </div>
      </span>
    </van-list>
  </div>
</template>

<script>
import { goodsGuessLike } from "@/api/tb";
export default {
  name:'TwoColumns',
  data() {
    return {
      goods_list:[],
      page:1,
      loading: false,
      finished: false,
      i:0
    };
  },
  created(){
    this.goods_list = []
    this.getLikeData()
    console.log(123);
  },
  mounted () {
    // if(this.$store.state.userId == ''){
    //   let x = setInterval(() => {
    //     if(this.$store.state.userId !== ''){
    //       goodsGuessLike({userId:this.$store.state.userId,page:this.page}).then(res=>{
    //         this.goods_list = res.data
    //       })   
    //       clearInterval(x)
    //     }
    //   }, 500);
    // }else{
    //   goodsGuessLike({userId:this.$store.state.userId}).then(res=>{
    //     this.goods_list = res.data
    //   })         
    // }
    
  },
  methods: {
    toDetail(no){
      this.$router.push('/detail?no='+no)

      // this.goods_list = []
      // this.getLikeData()
    },
    getLikeData(){
      
      goodsGuessLike({
        userId:this.$store.state.userId,
        page:this.page,
        goodsNo:this.$route.query.no?this.$route.query.no:''
      }).then(res=>{
        console.log('twc');
        this.goods_list = this.goods_list.concat(res.data)
        if(res.data.length === 0){
          this.finished = true
        }else{
          this.loading = false
          this.page += 1 
          this.finished = false
          
        }
 
      })   
    }
  },
};
</script>

<style lang="less" scoped>
.commodity{
  font-size: 1.5rem;
  // padding: 1vw;
  // display: flex;
  .card{
    width: 48vw;
    margin: 1vw;
    display: inline-block;
    
    background-color: #fff;
    border-radius: 6px;
    .shop{
      font-size: 1rem;
      color: #8a8a8a;
      display: flex;
      align-items: center;
      opacity: .7;
      padding: 0 .2rem;
      img{
        width: 1.7rem;
        height: 1.7rem;
        vertical-align: bottom;
        // vertical-align: bottom;
      }
    }
    .img{
      width: 48vw;
      height: 48vw;

      img{
        border-radius: 6px;
        width: 100%;
        height: 100%;
      }
    }
    .title{

      // display: flex;
      // align-items: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin: 0.6rem 0;
      padding: 0 .4rem;
      font-size: 1.3rem;
      
      // -webkit-line-clamp: 1;
      img{
        width: 1.4rem;
        height: 1.4rem;
        vertical-align: bottom;
        margin-right: 2px;
      }
    }
    .profit{
      display: flex;
      justify-content: space-between;
      margin: 0.8rem 0;
      padding: 0 .4rem;
      font-size: 1.2rem;
      .coupon_discount{
        width: 7.3rem;
        height: 1.8rem;
        background-color: #F63A25;
        color: rgb(245, 245, 245);
        font-size: 1.1rem;
        text-align: center;
        line-height: 1.8rem;
        border-radius: 3px;
        position: relative;
        &::before{
          content: '';
          width: 0.6rem;
          height: 0.6rem;
          position:absolute;
          background-color: #fff;
          border-radius: 50%;
          left: -0.3rem;
          top: 0.6rem;
        }
        &::after{
          content: '';
          width: 0.6rem;
          height: 0.6rem;
          position:absolute;
          background-color: #fff;
          border-radius: 50%;
          right: -0.3rem;
          top: 0.6rem;
        }
      }
      .profit_tips{
        padding:0 .6rem;
        box-sizing: border-box;
        // width: 8rem;
        text-align: center;
        line-height: 1.8rem;
        height: 1.8rem;
        background-color: rgb(255,242,203)	;
        border-radius: 3px;
        color: rgb(155, 10, 15);
        font-size: 1.1rem;
      }
    }
    .bottom{
      padding: 0 .4rem;
      display: flex;
      justify-content: space-between;
      padding-bottom: .8rem;
      align-items: center;
      .price{
        :nth-child(1){
          color: red;
          font-size: 1.5rem;
          font-weight: 600;
        }
        :nth-child(2){
          color: rgba(190, 190, 190, .9);
          font-size: 1rem;
          margin-left: 2px;
          position: relative;
          &::after{
            content: ' ';
            width: 4.6rem;
            height: 1px;
            background-color: rgba(190, 190, 190, .9);
            position: absolute;
            left: 0px;
            top: .6rem;
          }
        }
      }
      .sales_tip{
        font-size: 1rem;
        color: rgba(190, 190, 190, .9);
      }
    }
  }

}
</style>
